import React from 'react';
// import sections
import Hero from '../components/sections/Hero';
import FeaturesTiles from '../components/sections/FeaturesTiles';
import FeaturesSplit from '../components/sections/FeaturesSplit';
// import Testimonial from '../components/sections/Testimonial';
// import Cta from '../components/sections/Cta';
import Cta2 from '../components/sections/Cta2';
const Home = () => {
  return (
    <>
      <Hero className="illustration-section-01" />
      <FeaturesTiles className="illustration-section-02" />

      <FeaturesSplit
        invertMobile
        topDivider
        imageFill
        className="illustration-section-03"
      />
      {/* <Testimonial bottomDivider /> */}
      {/* <Cta split topDivider /> */}
      <Cta2 />
    </>
  );
};

export default Home;
